import { Interface, namespace } from '../../../../../../FrontendBundle/Resources/js/ofcs';

namespace('Ofcs.Editor.Item.Validator');

/**
 * @class ValidatorInterface
 */
export default window.Ofcs.Editor.Item.Validator.ValidatorInterface = new Interface({
    validate() {},
});
